import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

export const MyDocumentRequest = {
  getList: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/resources/`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params,
    }),

  getSharedList: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/resources/share`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params,
    }),

  create: body =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/resources/`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: body,
    }),

  rename: (id, body) =>
    axios({
      method: 'patch',
      url: `${apiUrl}/api/v1/resources/rename/${id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: body,
    }),

  move: (srcId, desId) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/resources/move/${srcId}${desId ? `/${desId}` : ''}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  share: (id, body) =>
    axios({
      method: 'patch',
      url: `${apiUrl}/api/v1/resources/share/${id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: body,
    }),

  publish: (id, body) =>
    axios({
      method: 'patch',
      url: `${apiUrl}/api/v1/resources/published/${id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: body,
    }),

  delete: id =>
    axios({
      method: 'delete',
      url: `${apiUrl}/api/v1/resources/${id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
}
